import { Theme } from '@eversports/react-components/design-tokens/theme'
import { HorizontalFlex, SimpleFlex } from '@eversports/react-components/primitives/Flex'
import Icon from '@eversports/react-components/primitives/Icon'
import VisaIcon from '@eversports/react-components/primitives/Icon/custom-icons/Visa'
import MasterCardIcon from '@eversports/react-components/primitives/Icon/custom-icons/MasterCard'
import RadioButton from '@eversports/react-components/primitives/RadioButton'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'
import React from 'react'

import { StoredCreditCard as StoredCreditCardType } from '../../typings/Payment'

const useStyles = makeStyles((theme: Theme) => ({
  root: ({ isSelected }: { isSelected: boolean }) => ({
    border: theme.borders.strong,
    borderColor: isSelected ? theme.palette.primary.main : theme.palette.divider,
    borderRadius: theme.borderRadii.default,
    padding: `calc(${theme.spacing(1)} / 2) ${theme.spacing(1)}`,
    cursor: 'pointer',
    width: '100%',
  }),
  fullWidth: {
    width: '100%',
  },
  flexGrow: {
    flexGrow: 1,
  },
}))

interface Props {
  card: StoredCreditCardType
  isSelected: boolean
}

const StoredCreditCard: React.FC<React.PropsWithChildren<Props>> = ({ card, isSelected }) => {
  const classes = useStyles({ isSelected })

  const { pspId, brand, expirationMonth, expirationYear, last4 } = card
  const cardDisplayNumber = `**** **** **** ${last4}`

  return (
    <SimpleFlex className={classes.root} as="label">
      <HorizontalFlex alignItems="center" horizontalSpacing="dense" className={classes.fullWidth}>
        <RadioButton name="cardId" value={pspId} />
        <Icon size="x-large" icon={brand === 'visa' ? VisaIcon : MasterCardIcon} />
        <HorizontalFlex horizontalSpacing="dense" className={classes.flexGrow}>
          <Text size="small">{cardDisplayNumber}</Text>
        </HorizontalFlex>
        <Text size="small">{`${expirationMonth}/${expirationYear}`}</Text>
      </HorizontalFlex>
    </SimpleFlex>
  )
}

export default React.memo(StoredCreditCard)
